import { royalBluePaletteDark } from '../../../themes/dark-colors';

export const spinnerDarkTheme = {
  color: royalBluePaletteDark[1000],
};
